<template>
  <router-view name="shop" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Shop",
};
</script>